import { render, staticRenderFns } from "./WxShare.vue?vue&type=template&id=d6b66df4&scoped=true&"
import script from "./WxShare.vue?vue&type=script&lang=js&"
export * from "./WxShare.vue?vue&type=script&lang=js&"
import style0 from "./WxShare.vue?vue&type=style&index=0&id=d6b66df4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b66df4",
  null
  
)

export default component.exports